// import {InputProps, ValidationError, useInput, useTranslate} from 'ra-core';
import clsx from 'clsx';
import HelperText from './shared/HelperText';
import ErrorText from './shared/ErrorText';
import {Textarea} from '@/shadcn_components/ui/textarea';
import {InputProps, useInput} from '@/hooks/useInput';
import {Label} from '@/shadcn_components/ui/label';

export type TextareaInputProps = InputProps & Partial<React.ComponentProps<'textarea'>>;

const TextareaInput = (props: TextareaInputProps) => {
  const {placeholder} = props;
  const {field, fieldState} = useInput(props);
  // const translate = useTranslate();
  const {className} = props;

  return (
    <div className={clsx('form-control w-full', className)}>
      <Label
      //  className='text-lg'
      >
        {props.label}
      </Label>
      <Textarea {...field} placeholder={placeholder} />
      <HelperText helperText={props.helperText} />
      <ErrorText {...fieldState} />
    </div>
  );
};

export default TextareaInput;
